import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { Survey } from '@/utils/types';
import { handleGlobalSearch } from '@/utils';

export const surveyApi = createApi({
	reducerPath: 'surveyApi',
	tagTypes: ['survey', 'surveyAnswers', 'surveyStatistics'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		addSurvey: builder.mutation({
			query: (body: Survey) => ({
				url: `surveys`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['survey'],
		}),
		addSurveyAnswer: builder.mutation({
			query: ({ id, body }) => ({
				url: `surveys/${id}/add-answer`,
				method: 'POST',
				body,
			}),
		}),
		getQuestions: builder.query({
			query: ({ attendeeId, surveyId }: { attendeeId: string; surveyId: string }) => ({
				url: `surveys/${surveyId}/questions`,
				params: { attendeeId },
			}),
			providesTags: ['survey'],
		}),
		getSurveyStatistics: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `surveys/${id}/statistics`,
			}),
			providesTags: ['survey'],
		}),
		getSurveyAnswers: builder.query({
			query: ({ id, filters, page }: { id: string; page: number; filters: any }) => ({
				url: `surveys/${id}/answers`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['surveyAnswers'],
		}),
		updateSurvey: builder.mutation({
			query: ({ id, body }: { id: string; body: Partial<Survey> }) => ({
				url: `surveys/${id}`,
				method: 'PATCH',
				body,
			}),
			invalidatesTags: ['survey'],
		}),
	}),
});

export const {
	useGetSurveyStatisticsQuery,
	useAddSurveyMutation,
	useGetSurveyAnswersQuery,
	useUpdateSurveyMutation,
	useGetQuestionsQuery,
	useAddSurveyAnswerMutation,
} = surveyApi;
